/// <amd-module name="TFS/CreateProject/Components/CollectionNameTextField" />
import { Label } from "OfficeFabric/Label";
import { TextField } from "OfficeFabric/TextField";
import * as React from "react";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import { getId } from "VSS/Core/Util/Object";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

export interface ICollectionNameTextFieldProps {
    hostName: string;
}

export class CollectionNameTextField extends VssComponent<ICollectionNameTextFieldProps, {}> {
    private _collectionNameTextFieldId: string;

    constructor(props: ICollectionNameTextFieldProps, context: IVssComponentContext) {
        super(props, context);

        this._collectionNameTextFieldId = getId("collection-name-textfield");
    }

    public render(): JSX.Element {
        const { hostName } = this.props;

        return (
            <div className="collection-name-container">
                <Label htmlFor={this._collectionNameTextFieldId}>{CreateProjectResources.CreateProjectCollectionNameContainerHeader}</Label>
                <TextField className="text-input" id={this._collectionNameTextFieldId} value={hostName} disabled />
            </div>
        );
    }
}
